import { handleActions } from 'redux-actions';
import * as constants from './constants';

export const initialState = {
  locationUid: '',
  organizationUid: '',
  userUid: '',
  sendVia: '',
  language: 'en',
  sendTo: '',
  customerName: '',

  isTest: true,
  error: '',
  status: '',
};

function resetReviewInvite() {
  return initialState;
}

function setLocation(state, { payload }) {
  const { locationUid, organizationUid, userUid } = payload;
  return {
    ...state,
    locationUid,
    organizationUid,
    userUid,
  };
}

export function updateSendVia(state, { payload }) {
  return {
    ...state,
    sendVia: payload,
  };
}

export function updateIsTest(state) {
  return {
    ...state,
    isTest: !state.isTest,
  };
}

export function updateLanguage(state, { payload }) {
  return {
    ...state,
    language: payload,
  };
}

export function updateSendTo(state, { payload }) {
  return {
    ...state,
    sendTo: payload,
  };
}

export function updateCustomerName(state, { payload }) {
  return {
    ...state,
    customerName: payload,
  };
}

export function sendReviewInviteFailure(state, { payload }) {
  return {
    ...state,
    error: payload,
    isSending: false,
  };
}

export function sendReviewInviteRequest(state) {
  return {
    ...state,
    isSending: true,
  };
}

export function sendReviewInviteSuccess(state) {
  return {
    ...state,
    isSending: false,
  };
}

export default handleActions(
  {
    [constants.RESET_REVIEW_INVITE]: resetReviewInvite,
    [constants.SET_REVIEW_INVITE_LOCATION]: setLocation,

    [constants.UPDATE_SEND_VIA]: updateSendVia,
    [constants.UPDATE_IS_TEST]: updateIsTest,
    [constants.UPDATE_LANGUAGE]: updateLanguage,
    [constants.UPDATE_SEND_TO]: updateSendTo,
    [constants.UPDATE_CUSTOMER_NAME]: updateCustomerName,

    [constants.SEND_REVIEW_INVITE_REQUEST]: sendReviewInviteRequest,
    [constants.SEND_REVIEW_INVITE_SUCCESS]: sendReviewInviteSuccess,
    [constants.SEND_REVIEW_INVITE_FAILURE]: sendReviewInviteFailure,
  },
  initialState
);
